var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 9.5H14.2498V12.6667H12.6665V9.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 5.54167V3.95833C15.8335 3.08512 15.1234 2.375 14.2502 2.375H3.9585C2.64908 2.375 1.5835 3.44058 1.5835 4.75V14.25C1.5835 15.9925 3.00375 16.625 3.9585 16.625H15.8335C16.7067 16.625 17.4168 15.9149 17.4168 15.0417V7.125C17.4168 6.25179 16.7067 5.54167 15.8335 5.54167ZM3.9585 3.95833H14.2502V5.54167H3.9585C3.75466 5.53255 3.56219 5.44516 3.42117 5.29769C3.28015 5.15022 3.20145 4.95404 3.20145 4.75C3.20145 4.54596 3.28015 4.34978 3.42117 4.20231C3.56219 4.05484 3.75466 3.96745 3.9585 3.95833ZM15.8335 15.0417H3.968C3.60225 15.0322 3.16683 14.8873 3.16683 14.25V6.97854C3.41541 7.068 3.67904 7.125 3.9585 7.125H15.8335V15.0417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.774e31c5821e8ecab1ba815b7517f2d4.svg";
export { ForwardRef as ReactComponent };